import { connect, useSelector } from "react-redux";
import { useState } from "react";
// Gojko
import { ReactComponent as LogoSO } from "../../assets/images/smartocto-logo.svg";
import { ReactComponent as LogoSOLight } from "../../assets/images/smartocto-logo-light.svg";

const Header = (props: any) => {
	const [currentTheme, setCurrentTheme] = useState("dark");
	const logo = useSelector(
		(state: any) => state.brandsettings.data?.domainSettings?.domainlogo
	);
	const data = useSelector((state: any) => state.goal.data);

	const toggleColorTheme = () => {
		if (currentTheme === "light") {
			setCurrentTheme("dark");
			document.body.classList.remove("light");
		} else {
			setCurrentTheme("light");
			document.body.classList.add("light");
		}
	};

	return (
		<div className="header">
			<div className="header__align-left">
				{logo && (
					<div className="header__brands">
						<div className="header-brand">
							<img src={logo} alt="brand" />
						</div>
					</div>
				)}
				<div className="header__info">{data.title}</div>

				{/*<div className={`header__nav active-${activeGrid}`}>*/}
				{/*	<div*/}
				{/*		className="nav nav1"*/}
				{/*		onClick={() => switchLayout(1)}*/}
				{/*	></div>*/}

				{/*	<div*/}
				{/*		className="nav nav2"*/}
				{/*		onClick={() => switchLayout(2)}*/}
				{/*	></div>*/}

				{/*	<div*/}
				{/*		className="nav nav3"*/}
				{/*		onClick={() => switchLayout(3)}*/}
				{/*	></div>*/}
				{/*</div>*/}
			</div>

			<div
				className="header__align-right"
				onClick={() => toggleColorTheme()}
			>
				{currentTheme === "light" ? <LogoSOLight /> : <LogoSO />}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	return { dashboard: state.dashboard };
};

export default connect(mapStateToProps)(Header);
